import React from 'react'

export default function footer() {
    return (
        <footer className="footer" >
            <p className="footer-text fs-14 fw-normal" >designed by <a  rel="noreferrer" target="_blank" className="footer-link fw-600" href="https://codeit.al/"> CodeIT </a></p>
        </footer>
    )
}
